/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type Image, ImageSchema } from './image'
import {
  type SectionBannerBackgroundApiProps,
  SectionBannerBackgroundApiPropsSchema,
} from './section-banner'

/* TypeScript */
export type EmailCollectorApiProps = {
  technicalName?: Maybe<string>
  image?: Maybe<Image>
  title: string
  text?: Maybe<string>
  buttonLabel?: Maybe<string>
  checkboxLabel?: Maybe<string>
  pdf?: Maybe<{
    url: string
    label: string
  }>
  emailCollectorTerms?: Maybe<{
    text: string
    hide: boolean
  }>
} & SectionBannerBackgroundApiProps

/* Schemas */
export const EmailCollectorApiPropsSchema = z.intersection(
  z.object({
    technicalName: z.nullish(z.string()),
    image: z.nullish(ImageSchema),
    title: z.string(),
    text: z.nullish(z.string()),
    buttonLabel: z.nullish(z.string()),
    checkboxLabel: z.nullish(z.string()),
    pdf: z.nullish(
      z.object({
        url: z.string(),
        label: z.string(),
      }),
    ),
    emailCollectorTerms: z.nullish(
      z.object({
        text: z.string(),
        hide: z.boolean(),
      }),
    ),
  }),
  SectionBannerBackgroundApiPropsSchema,
)

/* Schemas validation */
type TestEmailCollectorApiProps = ExpectTrue<
  Equal<EmailCollectorApiProps, z.infer<typeof EmailCollectorApiPropsSchema>>
>
